import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const DeveloperOptionsIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m8 8-4 4 4 4m8 0 4-4-4-4m-2-3-4 14"
        fill="white"
      />
    </svg>
  );
};
